var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRow35(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1322_38559)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 8,
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7978 26.8613H40.918L40.9233 33.4007H44.4747V32.5907H41.7978V26.8613Z",
    fill: "#8C929D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8607 32.2481C47.6408 32.4788 47.2706 32.7095 46.7717 32.7095C46.1011 32.7095 45.8329 32.3822 45.8329 31.9531C45.8329 31.3039 46.2835 30.9928 47.2384 30.9928C47.4154 30.9928 47.7051 31.0143 47.8553 31.0411V32.2481H47.8607ZM46.9541 28.2891C46.246 28.2891 45.5969 28.5412 45.0872 28.9596L45.3984 29.4961C45.7578 29.2869 46.1977 29.0777 46.8253 29.0777C47.5442 29.0777 47.8661 29.4478 47.8661 30.0647V30.3866C47.7266 30.3544 47.4369 30.3383 47.2599 30.3383C45.7202 30.3383 44.9424 30.8748 44.9424 32.0067C44.9424 33.0152 45.5593 33.5249 46.4981 33.5249C47.1311 33.5249 47.7373 33.2352 47.9465 32.7685L48.1075 33.4068H48.719V30.054C48.719 28.9972 48.2577 28.2891 46.9541 28.2891Z",
    fill: "#8C929D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5521 32.7409C51.2249 32.7409 50.9352 32.7033 50.7153 32.6014V29.5704C51.0157 29.3183 51.3858 29.1413 51.8525 29.1413C52.7001 29.1413 53.0327 29.7421 53.0327 30.7077C53.0327 32.0918 52.5016 32.7409 51.5521 32.7409ZM51.9223 28.2883C51.1391 28.2883 50.7153 28.8248 50.7153 28.8248V27.9772L50.7099 26.8613H49.8516L49.8569 33.2398C50.2861 33.4168 50.8762 33.5187 51.5146 33.5187C53.1508 33.5187 53.9393 32.4726 53.9393 30.6648C53.9393 29.2325 53.2098 28.2883 51.9223 28.2883Z",
    fill: "#8C929D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2501 27.5698C33.0279 27.5698 33.5268 27.8273 33.8595 28.0901L34.235 27.4357C33.72 26.9851 33.0279 26.7383 32.293 26.7383C30.4261 26.7383 29.1172 27.8756 29.1172 30.1716C29.1172 32.5749 30.5281 33.5137 32.1428 33.5137C32.9528 33.5137 33.6395 33.3259 34.0901 33.1328L34.074 30.5632V29.7532H31.6761V30.5632H33.205L33.2211 32.5159C33.0226 32.6178 32.6739 32.6929 32.2018 32.6929C30.9036 32.6929 30.0345 31.8775 30.0345 30.1555C30.0345 28.4174 30.9358 27.5698 32.2501 27.5698Z",
    fill: "#8C929D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4296 26.8613H37.5713L37.5767 27.9611V31.7484C37.5767 32.8053 38.038 33.5134 39.3416 33.5134C39.524 33.5134 39.701 33.4973 39.8727 33.4651V32.6926C39.7493 32.7141 39.6152 32.7248 39.4757 32.7248C38.7569 32.7248 38.4403 32.3546 38.4403 31.7377V29.1252H39.8673V28.4063H38.4296V26.8613Z",
    fill: "#8C929D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3945 33.3953H36.2529V28.4062H35.3945V33.3953Z",
    fill: "#8C929D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3945 27.7197H36.2529V26.8613H35.3945V27.7197Z",
    fill: "#8C929D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9077 39.2534L19.5556 28.0254H12.2598L15.9077 39.2534Z",
    fill: "#E24329"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9078 39.2534L12.2599 28.0254H7.14746L15.9078 39.2534Z",
    fill: "#FC6D26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.14769 28.0254L6.03722 31.4372C5.9353 31.7484 6.04795 32.0917 6.31082 32.2795L15.908 39.2534L7.14769 28.0254Z",
    fill: "#FCA326"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.14746 28.0262H12.2599L10.0604 21.2615C9.94776 20.9128 9.45422 20.9128 9.34156 21.2615L7.14746 28.0262Z",
    fill: "#E24329"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9082 39.2534L19.5561 28.0254H24.6685L15.9082 39.2534Z",
    fill: "#FC6D26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6685 28.0254L25.779 31.4372C25.8809 31.7484 25.7682 32.0917 25.5054 32.2795L15.9082 39.2534L24.6685 28.0254Z",
    fill: "#FCA326"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6681 28.0262H19.5557L21.7551 21.2615C21.8678 20.9128 22.3613 20.9128 22.474 21.2615L24.6681 28.0262Z",
    fill: "#E24329"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 7.5,
    stroke: "white",
    strokeOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1322_38559"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 8,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRow35);
export default __webpack_public_path__ + "static/media/row-3-5.5f771bb20bc76d88da6e7f7f44516de7.svg";
export { ForwardRef as ReactComponent };